// 室内地图功能封装

import { addImageMarker } from '@/common/map'

// 室内地图POI点坐标
const INDOOR_MAP_POI_POINT = [113.340741, 23.147506]

// 室内地图POI图标
const INDOOR_MAP_POI_ICON = require('@/icon/indoormap/poi.png')

// wss 地址
const INDOOR_MAP_WSS_URL = 'wss://intranet.iot.huaweisoft.com/positioning/'

// UWB X轴 最大值
export const UWB_X_MAX = 37.79

// UWB Y轴 最大值
export const UWB_Y_MAX = 7.6

var ws = null

// 心跳包定时器
let heartBeatsInterval = null

// 在地图上加载POI点，作为室内地图的功能入口
export function loadIndoorMapPoi(vectorLayer) {
  addImageMarker(vectorLayer, INDOOR_MAP_POI_POINT, INDOOR_MAP_POI_ICON, 'indoormap')
}

/**
 * 初始化websocket，读取坐标数据
 * @param {*} handleMessage 处理接受事件
 */
export function initWss(handleMessage) {
  ws = new WebSocket(INDOOR_MAP_WSS_URL)
  ws.onopen = () => {
    console.log('indoor map ws conection')
    // 清空心跳包定时器
    if (heartBeatsInterval) {
      clearInterval(heartBeatsInterval)
    }
    ws.send('heartBeats')
    // 定时发送心跳
    heartBeatsInterval = window.setInterval(() => {
      ws.send('heartBeats')
    }, 5000)
  }
  // 自动重连
  ws.onclose = err => {
    console.log('indoor map ws close', err)
    setTimeout(() => {
      initWss(handleMessage)
    }, 1000)
  }

  // 自定义函数处理消息响应
  ws.onmessage = e => {
    if (e.data !== 'heartBeats') {
      handleMessage(JSON.parse(e.data))
    }
  }
}
